import { createQueryKeys } from 'utils/react-query-utils';

export const variantPaymentsKeys = createQueryKeys(
  'variant-payments',
  (createKey) => ({
    getVariantPayments: (props: unknown) =>
      createKey('get-variant-payments', props),
  }),
);
